import { Content } from './types'

const table: Content = {
    type: 'table',
    name: 'Tabel',
}

export default table
